
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.5 2h-13a1 1 0 00-1 1 1 1 0 001 1h13a1 1 0 001-1 1 1 0 00-1-1zm-5.79 3.29a1 1 0 00-1.42 0L7.05 9.54a1 1 0 000 1.41 1 1 0 001.41 0L11 8.41v5.73a4 4 0 102 0V8.41L15.54 11A1 1 0 0017 11a1 1 0 000-1.41zm2 12.71A2.67 2.67 0 1112 15.33 2.68 2.68 0 0114.67 18z"}})])
          )
        }
      }
    